export type InjectScriptOptions = {
	scriptId?: string;
	dataProperties?: Record<string, string>;
	targetElement?: HTMLElement;
};

/**
* Injects a script tag into the page.
* @returns A promise that resolves when the script tag has finished loading.
*/
export function injectScript(url: string, options: InjectScriptOptions = {}): Promise<HTMLScriptElement> {
	const scriptId = options ? options.scriptId : null;
	const dataProperties = options ? options.dataProperties : null;
	const targetElement = (options ? options.targetElement : null) || document.head;

	const script = document.createElement('script');

	if (scriptId)
		script.id = scriptId;

	if (dataProperties) {
		for (const key of Object.keys(dataProperties))
			script.dataset[key] = dataProperties[key];
	}

	script.src = url;
	script.async = true;

	const scriptReady = new Promise<HTMLScriptElement>((resolve, reject) => {
		script.onload = () => resolve(script);
		script.onerror = (error) => reject(error);
	});

	targetElement.appendChild(script);

	return scriptReady;
}